import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    // Header
    nav_home: 'Home',
    nav_services: 'Services',
    nav_destinations: 'Destinations',
    nav_excursions: 'Excursions',
    nav_vehicles: 'Vehicles',
    nav_contact: 'Contact',
    book_now: 'Book Now',
    // Hero
    hero_subtitle_top: 'Your Ride Across Dominican Republic',
    hero_title_1: 'Private Transportation',
    hero_title_2: 'Across Dominican Republic',
    hero_desc: 'Airport transfers, hotel transportation and private rides with professional service.',
    hero_pickup: 'Pickup (Airport or Hotel)',
    hero_destination: 'Destination',
    hero_date: 'Date',
    hero_passengers: 'Passengers',
    hero_check: 'Check Availability',
    hero_price_label: 'Estimated Price:',
    hero_price_note: 'Per vehicle, one-way transfer',
    hero_available: 'Available',
    hero_drivers: 'Licensed Drivers',
    hero_rated: 'Top Rated',
    select_airport: 'Search airport or hotel...',
    select_destination: 'Search destination...',
    search_placeholder: 'Search...',
    passenger: 'Passenger',
    passengers: 'Passengers',
    // Services
    services_label: 'What We Offer',
    services_title_1: 'Our',
    services_title_2: 'Services',
    services_desc: 'From airport pickups to exclusive VIP transfers, we provide comprehensive transportation solutions across Dominican Republic.',
    svc_airport: 'Airport Transfers',
    svc_airport_d: 'Reliable pickup and drop-off from Punta Cana International Airport to any hotel or destination.',
    svc_private: 'Private Transportation',
    svc_private_d: 'Exclusive private rides for couples, families, or solo travelers with personalized service.',
    svc_group: 'Group Transportation',
    svc_group_d: 'Comfortable vehicles for groups of any size, perfect for events and gatherings.',
    svc_excursion: 'Excursion Transport',
    svc_excursion_d: 'Transportation to popular excursions like Isla Saona, Santo Domingo, and more.',
    svc_vip: 'VIP Service',
    svc_vip_d: 'Premium vehicles with luxury amenities for the most discerning travelers.',
    svc_city: 'City Transfers',
    svc_city_d: 'Intercity transportation across Dominican Republic with comfort and safety.',
    learn_more: 'Learn More',
    // Map
    map_label: 'Service Coverage',
    map_title_1: 'Our',
    map_title_2: 'Destinations',
    map_desc: 'We cover the entire Dominican Republic. Select an airport to see routes and prices.',
    map_tab_airports: 'Airports',
    map_tab_destinations: 'Destinations',
    map_hotels_in: 'Hotels in',
    map_prices_from: 'Prices from',
    // Excursions
    exc_label: 'Explore Paradise',
    exc_title_1: 'Popular',
    exc_title_2: 'Excursions',
    exc_desc: 'Discover the most beautiful destinations in Dominican Republic with our comfortable transportation.',
    exc_all_groups: 'All group sizes',
    exc_book: 'Book This Excursion',
    // Vehicles
    veh_label: 'Our Fleet',
    veh_title_1: 'Premium',
    veh_title_2: 'Vehicles',
    veh_desc: 'Choose from our fleet of modern, well-maintained vehicles for any group size.',
    veh_ac: 'Air Conditioning',
    veh_driver: 'Professional Driver',
    veh_luggage: 'Luggage Space',
    veh_reserve: 'Reserve This Vehicle',
    // Testimonials
    test_label: 'What Our Clients Say',
    test_title_1: 'Customer',
    test_title_2: 'Reviews',
    test_desc: "Don't just take our word for it. Here's what our satisfied customers have to say.",
    test_verified: 'Verified Customer',
    test_avg: 'Average Rating',
    test_happy: 'Happy Customers',
    test_trips: 'Completed Trips',
    // Booking
    book_label: 'Book Your Ride',
    book_title_1: 'Make a',
    book_title_2: 'Reservation',
    book_desc: "Fill out the form below and we'll confirm your booking via WhatsApp.",
    book_transfer: 'Transfer',
    book_excursion: 'Excursion',
    book_name: 'Full Name',
    book_email: 'Email',
    book_whatsapp: 'WhatsApp Number',
    book_pickup_airport: 'Pickup (Airport or Hotel)',
    book_dest_zone: 'Destination Zone',
    book_hotel: 'Select Hotel (Optional)',
    book_select_exc: 'Select Excursion',
    book_date: 'Date',
    book_time: 'Time',
    book_passengers: 'Passengers',
    book_vehicle: 'Preferred Vehicle (Optional)',
    book_comments: 'Comments (Optional)',
    book_price_est: 'Estimated Price:',
    book_price_transfer: 'Per vehicle, one-way transfer',
    book_price_person: 'Per person',
    book_submit: 'Confirm Reservation',
    book_submitting: 'Submitting...',
    book_success: 'Reservation submitted successfully! We will contact you shortly.',
    book_error: 'Error submitting reservation. Please try again.',
    book_select_airport: 'Search airport or hotel...',
    book_select_dest: 'Search destination...',
    book_select_hotel: 'Search hotel...',
    book_select_exc_ph: 'Select excursion',
    book_select_vehicle: 'Select vehicle (optional)',
    book_flight_num: 'Flight number, special requests, etc.',
    book_one_way: 'One Way',
    book_round_trip: 'Round Trip',
    book_return_date: 'Return Date',
    book_return_time: 'Return Time',
    book_price_roundtrip: 'Per vehicle, round trip',
    book_trip_type: 'Trip Type',
    // Footer
    foot_desc: 'Your trusted partner for transportation across Dominican Republic. Professional service, comfort, and reliability.',
    foot_slogan: '"Your Ride Across Dominican Republic"',
    foot_links: 'Quick Links',
    foot_areas: 'Service Areas',
    foot_contact: 'Contact Us',
    foot_rights: 'All rights reserved.',
    foot_tagline: 'Professional Transportation Services in Dominican Republic',
    foot_admin: 'Admin Panel',
  },
  es: {
    nav_home: 'Inicio',
    nav_services: 'Servicios',
    nav_destinations: 'Destinos',
    nav_excursions: 'Excursiones',
    nav_vehicles: 'Vehículos',
    nav_contact: 'Contacto',
    book_now: 'Reservar',
    hero_subtitle_top: 'Tu Transporte en República Dominicana',
    hero_title_1: 'Transporte Privado',
    hero_title_2: 'en República Dominicana',
    hero_desc: 'Traslados al aeropuerto, transporte a hoteles y viajes privados con servicio profesional.',
    hero_pickup: 'Recogida (Aeropuerto u Hotel)',
    hero_destination: 'Destino',
    hero_date: 'Fecha',
    hero_passengers: 'Pasajeros',
    hero_check: 'Ver Disponibilidad',
    hero_price_label: 'Precio Estimado:',
    hero_price_note: 'Por vehículo, solo ida',
    hero_available: 'Disponible',
    hero_drivers: 'Choferes Licenciados',
    hero_rated: 'Mejor Calificados',
    select_airport: 'Buscar aeropuerto u hotel...',
    select_destination: 'Buscar destino...',
    search_placeholder: 'Buscar...',
    passenger: 'Pasajero',
    passengers: 'Pasajeros',
    services_label: 'Qué Ofrecemos',
    services_title_1: 'Nuestros',
    services_title_2: 'Servicios',
    services_desc: 'Desde recogidas en el aeropuerto hasta traslados VIP exclusivos, ofrecemos soluciones de transporte integrales en República Dominicana.',
    svc_airport: 'Traslados al Aeropuerto',
    svc_airport_d: 'Recogida y entrega confiable desde el Aeropuerto Internacional de Punta Cana a cualquier hotel o destino.',
    svc_private: 'Transporte Privado',
    svc_private_d: 'Viajes privados exclusivos para parejas, familias o viajeros solos con servicio personalizado.',
    svc_group: 'Transporte Grupal',
    svc_group_d: 'Vehículos cómodos para grupos de cualquier tamaño, perfectos para eventos y reuniones.',
    svc_excursion: 'Transporte a Excursiones',
    svc_excursion_d: 'Transporte a excursiones populares como Isla Saona, Santo Domingo y más.',
    svc_vip: 'Servicio VIP',
    svc_vip_d: 'Vehículos premium con comodidades de lujo para los viajeros más exigentes.',
    svc_city: 'Traslados entre Ciudades',
    svc_city_d: 'Transporte interurbano en República Dominicana con comodidad y seguridad.',
    learn_more: 'Ver Más',
    map_label: 'Cobertura de Servicio',
    map_title_1: 'Nuestros',
    map_title_2: 'Destinos',
    map_desc: 'Cubrimos toda la República Dominicana. Selecciona un aeropuerto para ver rutas y precios.',
    map_tab_airports: 'Aeropuertos',
    map_tab_destinations: 'Destinos',
    map_hotels_in: 'Hoteles en',
    map_prices_from: 'Precios desde',
    exc_label: 'Explora el Paraíso',
    exc_title_1: 'Excursiones',
    exc_title_2: 'Populares',
    exc_desc: 'Descubre los destinos más hermosos de República Dominicana con nuestro transporte cómodo.',
    exc_all_groups: 'Todos los grupos',
    exc_book: 'Reservar Excursión',
    veh_label: 'Nuestra Flota',
    veh_title_1: 'Vehículos',
    veh_title_2: 'Premium',
    veh_desc: 'Elige entre nuestra flota de vehículos modernos y bien mantenidos para cualquier tamaño de grupo.',
    veh_ac: 'Aire Acondicionado',
    veh_driver: 'Chofer Profesional',
    veh_luggage: 'Espacio para Equipaje',
    veh_reserve: 'Reservar Este Vehículo',
    test_label: 'Lo Que Dicen Nuestros Clientes',
    test_title_1: 'Reseñas de',
    test_title_2: 'Clientes',
    test_desc: 'No solo confíes en nuestra palabra. Esto es lo que dicen nuestros clientes satisfechos.',
    test_verified: 'Cliente Verificado',
    test_avg: 'Calificación Promedio',
    test_happy: 'Clientes Felices',
    test_trips: 'Viajes Completados',
    book_label: 'Reserva Tu Viaje',
    book_title_1: 'Hacer una',
    book_title_2: 'Reservación',
    book_desc: 'Completa el formulario y confirmaremos tu reserva por WhatsApp.',
    book_transfer: 'Traslado',
    book_excursion: 'Excursión',
    book_name: 'Nombre Completo',
    book_email: 'Correo Electrónico',
    book_whatsapp: 'Número de WhatsApp',
    book_pickup_airport: 'Recogida (Aeropuerto u Hotel)',
    book_dest_zone: 'Zona de Destino',
    book_hotel: 'Seleccionar Hotel (Opcional)',
    book_select_exc: 'Seleccionar Excursión',
    book_date: 'Fecha',
    book_time: 'Hora',
    book_passengers: 'Pasajeros',
    book_vehicle: 'Vehículo Preferido (Opcional)',
    book_comments: 'Comentarios (Opcional)',
    book_price_est: 'Precio Estimado:',
    book_price_transfer: 'Por vehículo, solo ida',
    book_price_person: 'Por persona',
    book_submit: 'Confirmar Reservación',
    book_submitting: 'Enviando...',
    book_success: '¡Reservación enviada exitosamente! Te contactaremos pronto.',
    book_error: 'Error al enviar la reservación. Intenta de nuevo.',
    book_select_airport: 'Buscar aeropuerto u hotel...',
    book_select_dest: 'Buscar destino...',
    book_select_hotel: 'Buscar hotel...',
    book_select_exc_ph: 'Seleccionar excursión',
    book_select_vehicle: 'Seleccionar vehículo (opcional)',
    book_flight_num: 'Número de vuelo, solicitudes especiales, etc.',
    book_one_way: 'Solo Ida',
    book_round_trip: 'Ida y Vuelta',
    book_return_date: 'Fecha de Regreso',
    book_return_time: 'Hora de Regreso',
    book_price_roundtrip: 'Por vehículo, ida y vuelta',
    book_trip_type: 'Tipo de Viaje',
    foot_desc: 'Tu socio de confianza para transporte en República Dominicana. Servicio profesional, comodidad y confiabilidad.',
    foot_slogan: '"Tu Transporte en República Dominicana"',
    foot_links: 'Enlaces Rápidos',
    foot_areas: 'Áreas de Servicio',
    foot_contact: 'Contáctanos',
    foot_rights: 'Todos los derechos reservados.',
    foot_tagline: 'Servicios de Transporte Profesional en República Dominicana',
    foot_admin: 'Panel Admin',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('es');

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'es' ? 'en' : 'es');
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLang must be used within LanguageProvider');
  return context;
}
